import React from 'react';
import { IconProps } from '../types/types';

const LTC: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 55" role="img" {...props}><path d="M27.478 54.846c15.09 0 27.324-12.233 27.324-27.324C54.802 12.432 42.57.198 27.478.198 12.388.198.154 12.431.154 27.522c0 15.09 12.233 27.324 27.324 27.324z" fill="#335E9F"/><path d="m15.334 44.286 4.07-13.222-4.433 1.353 1.177-3.256 4.07-1.265 5.687-18.711a.957.957 0 0 1 .913-.671h5.808a.954.954 0 0 1 .913 1.22l-4.62 15.445 4.169-1.177-.76 3.146-4.3 1.298-3.003 9.592h15.29c.462 0 .792.44.67.88l-1.33 4.862a.696.696 0 0 1-.671.506h-23.65z" fill="#fff"/></svg>
);

export default LTC;
